import {
  ArrowRight,
  Bot,
  Globe,
  Headphones,
  LucideIcon,
  MessageCircle,
  Phone,
  PhoneCall,
} from 'lucide-react';

import { colors } from './tokens';

export interface ContatoPreset {
  Icon: LucideIcon;
  iconColor: string;
  iconBgGradient: string;
  label: string;
  descricao: string;
  buttonText: string;
  buttonBg: string;
  buttonTextColor: string;
  buttonHoverBg: string;
  buttonHoverTextColor: string;
  ButtonIcon: LucideIcon;
  buttonIconPosition: 'left' | 'right';
}

const portal: ContatoPreset = {
  Icon: Globe,
  iconColor: colors.accent,
  iconBgGradient: `linear-gradient(135deg, ${colors.foreground} 0%, ${colors.foregroundLight} 100%)`,
  label: 'PORTAL WEB',
  descricao: 'Acesse o portal e negocie digitalmente',
  buttonText: 'Acessar Portal',
  buttonBg: colors.foreground,
  buttonTextColor: colors.white,
  buttonHoverBg: colors.accent,
  buttonHoverTextColor: colors.foreground,
  ButtonIcon: ArrowRight,
  buttonIconPosition: 'right',
};

const PRESETS: Record<number, ContatoPreset> = {
  1: {
    Icon: Bot,
    iconColor: colors.foreground,
    iconBgGradient: `linear-gradient(135deg, ${colors.accent} 0%, ${colors.accentLight} 100%)`,
    label: 'WHATSAPP',
    descricao: 'Resolva rapidamente pelo nosso atendimento no WhatsApp',
    buttonText: 'Iniciar Conversa',
    buttonBg: colors.accent,
    buttonTextColor: colors.foreground,
    buttonHoverBg: colors.primary,
    buttonHoverTextColor: colors.white,
    ButtonIcon: MessageCircle,
    buttonIconPosition: 'left',
  },

  3: {
    Icon: Phone,
    iconColor: colors.white,
    iconBgGradient: `linear-gradient(135deg, ${colors.primaryDark} 0%, ${colors.primaryDarkLight} 100%)`,
    label: 'RECEPTIVO',
    descricao: 'Ligue para nossa central e seja atendido',
    buttonText: 'Ligar Agora',
    buttonBg: colors.primaryDark,
    buttonTextColor: colors.white,
    buttonHoverBg: colors.foreground,
    buttonHoverTextColor: colors.white,
    ButtonIcon: Phone,
    buttonIconPosition: 'left',
  },

  4: {
    Icon: PhoneCall,
    iconColor: colors.accent,
    iconBgGradient: `linear-gradient(135deg, ${colors.foreground} 0%, ${colors.foregroundLight} 100%)`,
    label: 'RETORNO DE LIGAÇÃO',
    descricao: 'Deixe seu número e nós ligamos para você',
    buttonText: 'Deixar meu número',
    buttonBg: colors.foreground,
    buttonTextColor: colors.white,
    buttonHoverBg: colors.accent,
    buttonHoverTextColor: colors.foreground,
    ButtonIcon: PhoneCall,
    buttonIconPosition: 'left',
  },

  5: {
    Icon: Headphones,
    iconColor: colors.white,
    iconBgGradient: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 100%)`,
    label: 'CHAT ONLINE',

    descricao: 'Fale com um atendente pelo chat online',
    buttonText: 'Chamar Atendente',
    buttonBg: colors.primary,
    buttonTextColor: colors.white,
    buttonHoverBg: colors.primaryDark,
    buttonHoverTextColor: colors.white,
    ButtonIcon: MessageCircle,
    buttonIconPosition: 'left',
  },
  6: portal,
};

const DEFAULT_PRESET: ContatoPreset = {
  ...portal,
  label: 'ATENDIMENTO',
  descricao: 'Acesse este canal de atendimento',
  buttonText: 'Acessar',
};

export const getPreset = (tipoContatoId: number): ContatoPreset =>
  PRESETS[tipoContatoId] ?? DEFAULT_PRESET;
